import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { formatNumberWithCommas } from "../../utils/common";
import {
  BarChartAseanData,
  BarChartDataType,
} from "../pages/dashboard/DashBoard";

interface HotSpotInfoBarchartType {
  hotspot?: BarChartDataType[];
  dataType: "Thailand" | "Asean";
  hotspotAsean?: BarChartAseanData[];
}

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white flex flex-col gap-3 w-full h-auto p-4 rounded-xl">
        {payload.length > 1 ? (
          <>
            <p className="text-sm font-normal">{label}</p>
            <div className="flex flex-col gap-1">
              {payload.map((data: any, index: number) => (
                <div key={index} className="flex justify-between gap-2">
                  <div className="flex gap-1 items-center">
                    <div
                      className={`w-2 h-2 rounded-full ${getBackgroundColor(
                        data.dataKey
                      )}`}
                    />
                    <p className="text-sm font-light">{data.name}</p>
                  </div>
                  <p className="text-sm font-light">
                    {formatNumberWithCommas(data.value)}
                  </p>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="flex justify-between gap-2">
            <p className="text-sm font-normal">{label}</p>
            <p className="text-sm font-light">
              {formatNumberWithCommas(payload[0].value)}
            </p>
          </div>
        )}
      </div>
    );
  }

  return null;
};

function getBackgroundColor(lu_code_index: string) {
  if (lu_code_index === "lu_code_1") {
    return "bg-[#91E478]";
  } else if (lu_code_index === "lu_code_2") {
    return "bg-[#E865EE]";
  } else if (lu_code_index === "lu_code_3") {
    return "bg-[#3B923E]";
  } else if (lu_code_index === "lu_code_4") {
    return "bg-[#AF692E]";
  } else if (lu_code_index === "lu_code_5") {
    return "bg-[#F8EA6E]";
  } else {
    return "bg-[#C3C3BE]";
  }
}

const HotSpotInfoBarchart = ({
  hotspot,
  dataType,
  hotspotAsean,
}: HotSpotInfoBarchartType) => {
  const [widthCharts, setWidthCharts] = useState(1200);
  useEffect(() => {
    if (dataType === "Thailand") {
      if (hotspot) {
        setWidthCharts(hotspot.length * 130);
      } else {
        setWidthCharts(700);
      }
    } else {
      if (hotspotAsean) {
        setWidthCharts(hotspotAsean.length * 210);
      } else {
        setWidthCharts(700);
      }
    }
  }, [dataType, hotspotAsean, hotspot]);
  return (
    <div className="w-full h-full p-4">
      <div className="w-full h-auto overflow-x-scroll p-4">
        {dataType === "Thailand" ? (
          <>
            {hotspot && hotspot.length > 10 ? (
              <ResponsiveContainer width={widthCharts} height={300}>
                <BarChart
                  height={300}
                  data={hotspot}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <Tooltip content={<CustomTooltip />} />
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" interval={0} />
                  <YAxis
                    label={{
                      value: "จำนวนจุดความร้อน",
                      angle: -90,
                      position: "insideLeft",
                      offset: 1,
                      dy: 40,
                    }}
                  />
                  <Bar
                    dataKey="lu_code_1"
                    name="ป่าอนุรักษ์"
                    fill="#91E478"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_2"
                    name="เขต สปก."
                    fill="#E865EE"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_3"
                    name="ป่าสงวนแห่งชาติ"
                    fill="#3B923E"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_4"
                    name="พื้นที่ริมทางหลวง(50เมตร)"
                    fill="#AF692E"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_5"
                    name="พื้นที่เกษตร"
                    fill="#F8EA6E"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_6"
                    name="ชุมชนและอื่น ๆ"
                    fill="#C3C3BE"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <ResponsiveContainer width={"100%"} height={300}>
                <BarChart
                  height={300}
                  data={hotspot}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <Tooltip content={<CustomTooltip />} />
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" interval={0} />
                  <YAxis
                    label={{
                      value: "จำนวนจุดความร้อน",
                      angle: -90,
                      position: "insideLeft",
                      offset: 1,
                      dy: 40,
                    }}
                  />
                  <Bar
                    dataKey="lu_code_1"
                    name="ป่าอนุรักษ์"
                    fill="#91E478"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_2"
                    name="เขต สปก."
                    fill="#E865EE"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_3"
                    name="ป่าสงวนแห่งชาติ"
                    fill="#3B923E"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_4"
                    name="พื้นที่ริมทางหลวง(50เมตร)"
                    fill="#AF692E"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_5"
                    name="พื้นที่เกษตร"
                    fill="#F8EA6E"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                  <Bar
                    dataKey="lu_code_6"
                    name="ชุมชนและอื่น ๆ"
                    fill="#C3C3BE"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  />
                </BarChart>
              </ResponsiveContainer>
            )}
          </>
        ) : (
          <>
            {hotspotAsean && hotspotAsean.length > 5 ? (
              <ResponsiveContainer width={widthCharts} height={300}>
                <BarChart
                  height={250}
                  data={hotspotAsean}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <Tooltip content={<CustomTooltip />} />
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" interval={0} />
                  <YAxis
                    label={{
                      value: "จำนวนจุดความร้อน",
                      angle: -90,
                      position: "insideLeft",
                      offset: 1,
                      dy: 40,
                    }}
                  />
                  <Bar
                    dataKey="value"
                    name="name"
                    fill="#D55B26"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  >
                    {hotspotAsean?.map(
                      (entry: BarChartAseanData, index: number) => {
                        return <Cell key={index} fill={entry.color} />;
                      }
                    )}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <ResponsiveContainer width={"100%"} height={300}>
                <BarChart
                  height={250}
                  data={hotspotAsean}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <Tooltip content={<CustomTooltip />} />
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" interval={0} />
                  <YAxis
                    label={{
                      value: "จำนวนจุดความร้อน",
                      angle: -90,
                      position: "insideLeft",
                      offset: 1,
                      dy: 40,
                    }}
                  />
                  <Bar
                    dataKey="value"
                    name="name"
                    fill="#D55B26"
                    barSize={5}
                    radius={[10, 10, 10, 10]}
                  >
                    {hotspotAsean?.map(
                      (entry: BarChartAseanData, index: number) => {
                        return <Cell key={index} fill={entry.color} />;
                      }
                    )}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            )}
          </>
        )}
      </div>
      <div className="flex justify-around flex-wrap gap-4 2xl:gap-6 mt-8">
        {dataType === "Thailand" ? (
          <>
            <div className="flex gap-1 items-center">
              <div className="w-2 h-2 shrink rounded-full bg-custom-4" />
              <p className="text-xs font-normal text-gray-4">ป่าอนุรักษ์</p>
            </div>
            <div className="flex gap-1 items-center">
              <div className="w-2 h-2 shrink rounded-full bg-custom-2" />
              <p className="text-xs font-normal text-gray-4">เขต สปก.</p>
            </div>
            <div className="flex gap-1 items-center">
              <div className="w-2 h-2 shrink rounded-full bg-custom-5" />
              <p className="text-xs font-normal text-gray-4">ป่าสงวนแห่งชาติ</p>
            </div>
            <div className="flex gap-1 items-center">
              <div className="w-2 h-2 shrink rounded-full bg-custom-6" />
              <p className="text-xs font-normal text-gray-4">
                พื้นที่ริมทางหลวง(50เมตร)
              </p>
            </div>
            <div className="flex gap-1 items-center">
              <div className="w-2 h-2 shrink rounded-full bg-custom-1" />
              <p className="text-xs font-normal text-gray-4">พื้นที่เกษตร</p>
            </div>
            <div className="flex gap-1 items-center">
              <div className="w-2 h-2 shrink rounded-full bg-custom-3" />
              <p className="text-xs font-normal text-gray-4">ชุมชนและอื่น ๆ</p>
            </div>
          </>
        ) : (
          <>
            {hotspotAsean?.map((asean) => (
              <div key={asean.id} className="flex shrink gap-1 items-center">
                <div
                  style={{
                    backgroundColor: asean.color,
                    width: "8px",
                    height: "8px",
                    borderRadius: "100%",
                  }}
                />
                <p className="text-xs font-normal text-gray-4">{asean.name}</p>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default HotSpotInfoBarchart;
